import ServiceCategoryPage from "../components/ServiceCategoryPage";
import aluminiumWorkerService from "../data/services/aluminiumWorkerService";

function AluminiumWorker() {
  return <ServiceCategoryPage service={aluminiumWorkerService} />;
}

export default AluminiumWorker;